import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import wikifactoryTheme from 'styles/themes/wikifactory';

export const data = {
  colorsGlue: [
    ['50', '100'],
    ['100', '200'],
    ['200', '300'],
    ['300', '400'],
    ['400', '500'],
    ['500', '600'],
    ['600', '700'],
    ['700', '800'],
    ['800', '900'],
    ['900', ''],
  ],
  colorsList: [
    ['brand', 'wfBlue'],
    ['gray', 'wfGrey'],
    ['yellow', 'wfYellow'],
    ['blue', 'wfBlue'],
    ['green', 'wfGreen'],
    ['orange', 'wfOrange'],
    ['purple', 'wfPurple'],
    ['red', 'wfRed'],
  ],
};

const colorsObjGlue = name => {
  const output = {};
  const colors = wikifactoryTheme.color;
  data.colorsGlue.forEach(tuple => {
    output[tuple[0]] = colors[`${name}${tuple[1]}`];
  });

  return output;
};

const customInjection = obj => {
  const output = Object.assign({}, obj);

  // Typography
  const fontFamily = wikifactoryTheme.font.family.primary;
  output.fonts.body = fontFamily;
  output.fonts.heading = fontFamily;

  // Colors
  data.colorsList.forEach(tuple => {
    output.colors[tuple[0]] = colorsObjGlue(tuple[1]);
  });

  ['teal', 'cyan', 'pink'].forEach(key => {
    delete output.colors[key];
  });

  return output;
};

const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  // TODO: Override more components at this level to avoid rule duplication.
  // - https://github.com/chakra-ui/chakra-ui/tree/main/packages/theme/src/components
  components: {
    Checkbox: {
      baseStyle: {
        control: {
          _checked: {
            bg: 'blue',
            borderColor: 'blue',
          },
        },
      },
    },
  },
};
const theme = customInjection(
  extendTheme(config, withDefaultColorScheme({ colorScheme: 'blue' })),
);

export default theme;
